// extracted by mini-css-extract-plugin
module.exports = {"bsHeader":"bsHeader_IocK4","divider":"divider_9MCN4"};